import { render, staticRenderFns } from "./priceStock.vue?vue&type=template&id=ec9ee74e"
import script from "./priceStock.vue?vue&type=script&lang=js"
export * from "./priceStock.vue?vue&type=script&lang=js"
import style0 from "./priceStock.vue?vue&type=style&index=0&id=ec9ee74e&lang=less"
import style1 from "./priceStock.vue?vue&type=style&index=1&id=ec9ee74e&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec9ee74e')) {
      api.createRecord('ec9ee74e', component.options)
    } else {
      api.reload('ec9ee74e', component.options)
    }
    module.hot.accept("./priceStock.vue?vue&type=template&id=ec9ee74e", function () {
      api.rerender('ec9ee74e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/productDetail/priceStock.vue"
export default component.exports